module.exports = __webpack_public_path__ + "img/nbus_box_3-2.72f1b062.jpg";